/* @flow */

import React, { Component } from 'react';
import { Form, Grid, Image } from 'semantic-ui-react';
import ProgressiveImage from 'shared/components/ProgressiveImage';
import { getVideoPlaceholder } from 'utils/resources';
import loader from 'static/images/image-loader.svg';
import throttle from 'lodash/throttle';
import {
  THUMBNAIL_THROTTLE_MILLIS,
  tryExtractId,
  fetchThumbnail,
} from 'utils/youtube';

type Props = {
  block: EditorialYoutubeBlock,
  onSerialize?: (block: EditorialYoutubeBlock) => void,
  onCanSubmitChanged?: (value: boolean) => void,
};

type State = {
  value?: string,
  currentThumbnail?: string,
  error: boolean,
};

const blockToUrl = block => {
  return block.youtubeId
    ? `https://www.youtube.com/watch?v=${block.youtubeId}`
    : '';
};

class Edit extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      error: false,
      thumbnailThrottle: throttle(
        this.getThumbnail,
        THUMBNAIL_THROTTLE_MILLIS,
        { trailing: true }
      ),
    };
  }

  getThumbnail = id => {
    const canSubmit = value => this.props.onCanSubmitChanged(value);

    if (id) {
      canSubmit(false);
      fetchThumbnail(id).then(
        response => {
          const { video } = response;
          if (video) {
            this.setState({
              currentThumbnail: video.thumbnail,
            });

            this.props.onSerialize({
              ...this.props.block,
              thumbnail: video.thumbnail,
            });

            canSubmit(true);
          }
        },
        _ => {
          this.setState({
            error: false,
          });

          canSubmit(true);
        }
      );
    }
  };

  onUrlChanged = (event: SyntheticEvent) => {
    const { block, onSerialize } = this.props;

    if (event.target instanceof HTMLInputElement) {
      const { value } = event.target;

      const youtubeId = tryExtractId(value);
      const isValid = youtubeId !== null;

      this.setState({
        value,
        error: !isValid,
      });

      this.props.onCanSubmitChanged(false);

      if (isValid) {
        this.state.thumbnailThrottle(youtubeId);

        onSerialize({
          ...block,
          youtubeId,
        });
      }
    }
  };

  render() {
    const { block } = this.props;
    const { value, error } = this.state;

    const url = value || blockToUrl(block);
    const thumbnail =
      this.state.currentThumbnail || block.thumbnail || getVideoPlaceholder;

    return (
      <Grid>
        <Grid.Column width={4}>
          <ProgressiveImage
            src={thumbnail}
            crossOrigin={null}
            placeholder={loader}
          >
            {src => <Image src={src} />}
          </ProgressiveImage>
        </Grid.Column>
        <Grid.Column width={12} verticalAlign="middle">
          <Form>
            <Form.Input
              error={error}
              label="Lien vidéo Youtube"
              placeholder="https://www.youtube.com/watch?v="
              value={url}
              onChange={this.onUrlChanged}
            />
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/youtube/Edit.js